import React from 'react';
import styled from 'astroturf/react';
import $image_url from 'js/utils/image_url';
import { Button } from 'js/design_system/Button';
import { Body } from 'js/design_system/Body';
import { Heading as HeadingBase } from 'js/design_system/Heading';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { getSocialImpressionSource } from 'js/social/ImpressionHelper';
import { BigCardWrapper } from './BigCardWrapper';

const Graphic = styled.img`
  width: 136px;
  height: 136px;
`;

const Heading = styled(HeadingBase)`
  font-weight: 500;
  color: $ds-black;
  margin-top: 8px;
`;

const Description = styled(Body)`
  margin-bottom: 16px;
`;

const Cta = styled(Button)`
  width: 100%;

  @include for-tablet-up {
    margin-bottom: 8px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
`;

type Props = {
  onCtaClick?: () => void;
};

const IMPRESSION_PAGE = 'home';
const IMPRESSION_SECTION = 'feedhead';

export const BigCardDiscover: React.FC<React.PropsWithChildren<Props>> = ({
  onCtaClick = () => null,
  children,
}) => {
  return (
    <ImpressionWatcher
      source={getSocialImpressionSource(
        IMPRESSION_PAGE,
        IMPRESSION_SECTION,
        'discover-card',
      )}
    >
      <Wrapper>
        <BigCardWrapper>
          <Graphic
            alt="Discover Academics to Follow"
            src={$image_url('social/discover_academics.svg')}
          />
          <Heading size="sm">Discover Academics to Follow</Heading>
          <Description>
            Stay up-to-date with the latest research from academics around the
            world.
          </Description>
          <ImpressionWatcher
            source={getSocialImpressionSource(
              IMPRESSION_PAGE,
              IMPRESSION_SECTION,
              'discover-cta',
            )}
          >
            <Cta onClick={onCtaClick}>Discover academics to follow ▸</Cta>
          </ImpressionWatcher>

          {children}
        </BigCardWrapper>
      </Wrapper>
    </ImpressionWatcher>
  );
};
